import React from "react";
import { EmailInbox } from "../../../Components/Private/Email";

export default function StudentEmail() {
  return (
    <main className="main">
      <div className="applicant-status-body email-tab">
        <div className="email-nav rounded-3 overflow-hidden">
          <EmailInbox />
        </div>
      </div>
    </main>
  );
}
